<template>
  <div style="display:flex;flex-direction:row;">
    <div class="headLeft">
      <div class="main">
        <!-- <img src="@/assets/image/fangwu.png" class="FDleftImg" /> -->
        <img src="@/assets/image/leftlogo.png" class="leftImg" />
        <div v-for="item in list" :key="item.key" class="headLeftImg">
          <img v-if="item.key == 9" src="@/assets/image/huo.png" class="rightHuoImg" />
          <div :class="[chooseValue == item.key ? 'chineseOnclick' : 'chinese']" @click="chooseEvent(item.key)" @mouseover="mouseOver(item.key)" @mouseleave="mouseLeave()">
            {{ item.chinese }}
          </div>
          <div :class="[chooseValue == item.key ? 'englishOnclick' : 'english']" @click="chooseEvent(item.key)" @mouseover="mouseOver(item.key)" @mouseleave="mouseLeave()">
            {{ item.english }}
          </div>
        </div>
      </div>
    </div>

    <!-- 切换菜单 -->
    <div class="leftSwitch" v-show="showSwitch" @mouseleave="LeftMouseLeave()">
      <component :is="currentBizComponent" v-on:specialtyListFunction="changeMenuList"></component>
    </div>
    <!-- @mouseleave="LeftMouseLeave()" -->
  </div>
</template>

<script>
import { aboutInfoHitsById, getAboutInfo } from "@/api/common";
import OutlineSwitch from "@/views/outline/outlineSwitch.vue";
import NewsSwitch from "@/views/newsInfo/newsSwitch.vue";
import TrafficSwitch from "@/views/traffic/trafficSwitch.vue";
import HotelSwitch from "@/views/hotel/hotelSwitch.vue";
import FoodSwitch from "@/views/food/foodSwitch.vue";
import SpecialtySwitch from "@/views/specialty/specialtySwitch.vue";
import EnterSwitch from "@/views/entertainment/enterSwitch.vue";
import GuideSwitch from "@/views/guide/guideSwitch.vue";
import TicketSwitch from "@/views/ticket/ticketSwitch.vue";
import CultureSwitch from "@/views/culture/cultureSwitch.vue";
export default {
  name: "HeadLeft",
  components: {
    TicketSwitch,
    OutlineSwitch,
    NewsSwitch,
    TrafficSwitch,
    HotelSwitch,
    FoodSwitch,
    SpecialtySwitch,
    EnterSwitch,
    GuideSwitch,
    CultureSwitch
  },
  data() {
    return {
      currentBizComponent: "OutlineSwitch",
      chooseValue: 1,
      showSwitch: false,
      list: [
        { key: 1, chinese: "首页", english: "HOME" },
        { key: 10, chinese: "购票", english: "TICKETING" },
        { key: 2, chinese: "概括", english: "ABOUT" },
        { key: 3, chinese: "资讯", english: "NEWS" },
        { key: 4, chinese: "交通", english: "TRAFFIC" },
        { key: 5, chinese: "住宿", english: "HOTEL" },
        { key: 6, chinese: "美食", english: "FOOD" },
        { key: 7, chinese: "特产", english: "SPECIALTY" },
        { key: 8, chinese: "娱乐", english: "ENTERAINMENT" },
        { key: 9, chinese: "导游", english: "GUIDE" },
        { key: 11, chinese: "武夷山文化", english: "CULTURE" },
      ]
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        this.showSwitch = deviceId;
      },
      deep: true,
      immediate: true
    },
    pageId: {
      handler(pageId) {
        this.chooseValue = pageId;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    deviceId() {
      return this.$store.state.showSwitchMenu;
    },
    pageId() {
      return this.$store.state.childMenu;
    }
  },
  methods: {
    changeMenuList(name) {
      this.$emit("specialtyListFunction", name);
    },
    chooseEvent(type) {
      // 点击 浏览次数
      if (type === 2) {
        this.countHitsFun(type)
      }
      this.chooseValue = type;
      this.clickMenuJump(type);
      // this.$store.commit("setPage", type);
    },
    mouseLeave() {
      // this.chooseValue !== 1 ? this.chooseMenu(this.chooseValue) : "";
    },
    mouseOver(type) {
      this.chooseMenu(type);
    },
    LeftMouseLeave() {
      this.$store.commit("setShowSwitchMenu", false);
    },
    // 累加 概况（走进武夷山--web小程序）
    async countHitsFun(type) {
      const { code, data } = await getAboutInfo();
      if (code == 200) {
        this.sendHits(data[0].id)
      }
    },
    async sendHits(id) {
       await aboutInfoHitsById(id);
    },
    //菜单选中页面跳转
    clickMenuJump(key) {
      switch (key) {
        case 1:
          this.$store.commit("setPage", 1);
          break;
        case 2:
          this.$store.commit("setShowSwitchMenu", false);
          this.$store.commit("setTabPage", 1);
          this.$emit("specialtyListFunction", "TabApage");
          break;
        case 3:
          this.$store.commit("setShowSwitchMenu", false);
          this.$store.commit("setTabPage", 1);
          this.$emit("specialtyListFunction", "NewsTab");
          break;
        case 4:
          this.$store.commit("setShowSwitchMenu", false);
          this.$store.commit("setTabPage", 1);
          this.$emit("specialtyListFunction", "TrafficTab");
          break;
        case 5:
          this.$store.commit("setShowSwitchMenu", false);
          this.$store.commit("setTabPage", 1);
          this.$emit("specialtyListFunction", "TabHotel");
          break;
        case 6:
          this.$store.commit("setShowSwitchMenu", false);
          this.$store.commit("setTabPage", 1);
          this.$emit("specialtyListFunction", "TabFood");
          break;
        case 7:
          this.$store.commit("setShowSwitchMenu", false);
          this.$store.commit("setTabPage", 1);
          this.$emit("specialtyListFunction", "SpecialtyList");
          break;
        case 8:
          this.$store.commit("setShowSwitchMenu", false);
          this.$store.commit("setTabPage", 1);
          this.$emit("specialtyListFunction", "EnterTab");
          break;
        case 9:
          this.$store.commit("setShowSwitchMenu", false);
          this.$store.commit("setTabPage", 1);
          this.$emit("specialtyListFunction", "TabGuide");
          break;
        case 10:
          this.$store.commit("setPage", 10);
          break;
        case 11:
          this.$store.commit("setShowSwitchMenu", false);
          this.$store.commit("setTabPage", 1);
          this.$emit("specialtyListFunction", "CultureList");
          break;
        default:
          this.$store.commit("setPage", 1);
      }
    },
    //浮动菜单选择
    chooseMenu(key) {
      switch (key) {
        case 1:
          this.currentBizComponent = "OutlineSwitch";
          this.$store.commit("setShowSwitchMenu", false);
          break;
        case 2:
          this.currentBizComponent = "OutlineSwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
        case 3:
          this.currentBizComponent = "NewsSwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
        case 4:
          this.currentBizComponent = "TrafficSwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
        case 5:
          this.currentBizComponent = "HotelSwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
        case 6:
          this.currentBizComponent = "FoodSwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
        case 7:
          this.currentBizComponent = "SpecialtySwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
        case 8:
          this.currentBizComponent = "EnterSwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
        case 9:
          this.currentBizComponent = "GuideSwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
       case 10:
          this.currentBizComponent = "TicketSwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
        case 11:
          this.currentBizComponent = "CultureSwitch";
          this.$store.commit("setShowSwitchMenu", true);
          break;
        default:
          this.$store.commit("setShowSwitchMenu", false);
      }
    }
  }
};
</script>

<style scoped>
.leftSwitch {
  position: absolute;
  z-index: 12;
  left: 11.354vw;
}
.FDleftImg {
  position: absolute;
  left: 0%;
  top: -6%;
  width: 8%;
  height: 12%;
}
.headLeft {
  width: 11.458vw;
  height: 94.44vh;
  background: url(../../assets/image/leftImg.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
}
.headLeft .main {
  text-align: center;
}
.headLeft .leftImg {
  width: 8.958vw;
  height: 6.2037vh;
  margin-top: 3.61vh;
  margin-bottom: 1vh;
}
.headLeft .chinese {
  font-size: 1.8518vh;
  font-weight: 400;
  /* color: #005a51; */
  margin-top: 1.8518vh;
  cursor: pointer;
}

.headLeft .chineseOnclick {
  font-size: 1.8518vh;
  font-weight: 400;
  color: #d87001;
  margin-top: 1.8518vh;
  cursor: pointer;
}
.headLeft .english {
  font-size: 1.29629vh;
  font-weight: 400;
  /* color: #005a51; */
  cursor: pointer;
}

.headLeft .englishOnclick {
  font-size: 1.29629vh;
  font-weight: 400;
  color: #d87001;
  cursor: pointer;
}
.headLeft .rightHuoImg {
  width: 1.574vh;
  height: 2.22vh;
  position: absolute;
  z-index: 11;
  top: -0.92592vh;
  right: 3.38541vw;
}
.headLeftImg {
  position: relative;
  color: #005a51;
}
.headLeftImg:hover {
  position: relative;
  color: #d87001;
}
</style>



// WEBPACK FOOTER //
// src/components/common/headLeft.vue